import {} from '@fortawesome/free-brands-svg-icons';

export default [];
